var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('WebpartTemplate',[_c('div',{staticClass:"wpart-template1"},[_c('FileList',{on:{"mounted":_vm.onListMounted}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }